import s from './TourHero.module.scss';
import { CLOUDINARY_BASE_URL } from '../../config/cloudinary';
import { useLanguage } from '../../contexts/LanguageContext';

const TEXT = {
  JP: {
    kicker: 'Tours',
    title: '宮古島で選べる特別な非日常体験',
    description:
      '海・空・陸・秘境での撮影に特化した、1組限定のプライベートツアー。あなただけの特別な瞬間をお届けし、一生忘れられない思い出としてプレゼントします。',
    points: [
      '1組限定プライベート',
      '撮影データ付き',
      '宮古島全域ご案内',
    ],
    alt: '宮古島ツアー',
  },
  EN: {
    kicker: 'Tours',
    title: 'Special experiences in Miyakoisland',
    description:
      'Private tours limited to one group, focused on photography and filming across the ocean, sky, land, and hidden spots. We capture your special moments and turn them into unforgettable memories.',
    points: [
      'Private tour for one group',
      'Photo data included',
      'Guided across Miyako Island',
    ],
    alt: 'Miyako Island tour',
  },
  中文: {
    kicker: 'Tours',
    title: '在宫古岛选择特别体验',
    description:
      '专注于海、空、陆地和秘境拍摄的一组限定私人旅行。为你记录专属的特别瞬间，留下终生难忘的回忆。',
    points: [
      '一组限定私人行程',
      '包含拍摄数据',
      '带你探索宫古岛全域',
    ],
    alt: '宫古岛旅行',
  },
  한국어: {
    kicker: 'Tours',
    title: '미야코지마에서 만나는 특별한 경험',
    description:
      '바다, 하늘, 육지, 숨겨진 명소에서의 촬영에 특화된 한 팀 한정 프라이빗 투어입니다. 당신만의 특별한 순간을 평생 잊지 못할 추억으로 남겨드립니다.',
    points: [
      '한 팀 한정 프라이빗',
      '촬영 데이터 포함',
      '미야코지마 전역 안내',
    ],
    alt: '미야코지마 투어',
  },
};

const ToursHero = () => {
  const { lang } = useLanguage();
  const t = TEXT[lang] || TEXT.JP;

  return (
    <section className={s.root}>
      <div className={s.content}>
        <span className={s.kicker}>{t.kicker}</span>

        <h1>{t.title}</h1>

        <p>{t.description}</p>

        <div className={s.points}>
          {t.points.map((point, index) => (
            <div key={point}>
              <span>{String(index + 1).padStart(2, '0')}</span>
              <p>{point}</p>
            </div>
          ))}
        </div>
      </div>

      <div className={s.visual}>
        <img
          src={`${CLOUDINARY_BASE_URL}v1784266410/DJI_20260714133703_0069_D_cp1tbk.webp`}
          alt={t.alt}
        />
      </div>
    </section>
  );
};

export default ToursHero;
